module.exports = __webpack_public_path__ + "img/emotion_management.5b3f8ebb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emotion_management.png
// module id = Phjz
// module chunks = 0